import Vue from 'vue';

/** Event bus for sending users events. */
const UsersEventBus = new Vue();

export default UsersEventBus;
